import styles from "../../../pages/Admin/Admin.module.css";
import {Link} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {ReactComponent as AjouterIcone} from "../../../icons/ajouter.svg";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAddressCard,
    faBuilding,
    faEdit,
    faExternalLink,
    faSquareCheck,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import {fetchSetActiviteTypeActif} from "../../../services/ActivitesService";
import AxiosConfig from "../../../services/AxiosConfig";
import {useModal} from "../../../contexts/ModalContext";
import {ImageIllustrationUpload} from "../../Image/ImageIllustrationUpload";
import {Form, Formik} from "formik";
import Routing from "../../../services/routing";

const ActiviteTypeVue = ({ activiteType }) => {
    const [data, setData] = useState(activiteType);
    const {showModal, hideModal} = useModal();
    const fileInputRef = useRef(null);


    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const putActifOpenModal = (actType) => {
        const text = actType.actActif ? "supprimer" :  "activer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} ce type d'activité ?`,
            onConfirm: async () => {
                const response = await fetchSetActiviteTypeActif(data);
                if (response.success) {
                    handleSuccess(response.message);
                } else {
                    handleError(response.message);
                }
                setTimeout(() => {
                    (async () => {
                        try {
                            const response = await AxiosConfig.get(`/admin/activites/types/${data.actId}`);
                            setData(response.data.myActiviteType);
                        } catch (error) {
                            console.error('error', error);
                            handleError("Erreur : "+error);
                        }
                    })();
                }, 500);
            }
        });
    }

    const handleSubmitLogo = async (values, {setSubmitting, resetForm, setErrors}) => {
        if (values.file) {
            const formData = new FormData();
            formData.append("file", values.file);

            try {
                const response = await AxiosConfig.post(`/admin/activites/types/${activiteType.actId}/logo`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.data.success) {
                    handleSuccess("Logo enregistré avec succès");
                    setData(prevState => ({
                        ...prevState,
                        actLogo: `${response.data.rez.actLogo}?t=${new Date().getTime()}`
                    }));
                } else {
                    handleError("Logo non enregistré suite à une erreur.");
                }
                resetForm();
            } catch (error) {
                console.error("Erreur lors de l'upload du fichier", error);
            }
        } else {
            setErrors({file: "Un fichier est requis"});
        }

        setSubmitting(false);
    };

    const handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };


    useEffect(() => {
        setData(activiteType);
    }, [activiteType]);

    return (
        <>
            <div style={{ minWidth: "400px" }} >
                <div className={styles.headerBtnsVue}>
                    { !data.actLogo && <Link to={Routing.routes.adminCreation}><AjouterIcone/>Ajouter un logo</Link> }
                    <button onClick={putActifOpenModal}>{data.actActif ? <><FontAwesomeIcon
                        icon={faXmark}/>Supprimer</> : <><FontAwesomeIcon
                        icon={faSquareCheck}/>Restaurer</>}</button>
                    <Link to={Routing.routes.adminCreation}><FontAwesomeIcon icon={faEdit}/>Modifier</Link>
                </div>

                {/* <ImageIllustration src={data.actLogo} alt={data.actLabel} openImage={true}/> */}
                <ImageIllustrationUpload src={data.actLogo} alt={data.actLabel} onClick={handleClick}/>
                <Formik
                    initialValues={{file: null}}
                    onSubmit={handleSubmitLogo}
                >
                    {({setFieldValue, submitForm, isSubmitting, errors}) => (
                        <Form style={{display: "flex", flexDirection: "column"}}>
                            <input
                                id="file"
                                className={styles.inputFileLogo}
                                name="file"
                                type="file"
                                style={{display: 'none'}}
                                ref={fileInputRef}
                                onChange={(event) => {
                                    setFieldValue("file", event.currentTarget.files[0]);
                                    submitForm();
                                }}
                            />
                            {errors.file ? <div style={{color: 'red'}}>{errors.file}</div> : null}
                        </Form>
                    )}
                </Formik>

                <div style={{
                    padding: "10px",
                    margin: "1rem 0",
                    color: data.actColorFont,
                    backgroundColor: data.actColorBkg,
                    borderRadius: "5px"
                }}>
                    <p style={{fontStyle: "italic", margin: "1rem 10px"}}>"{data.actSlogan}"</p>
                </div>

                <p style={{margin: "1rem 0"}}>{data.actDescription}</p>

            </div>
        </>
    )
}

export default ActiviteTypeVue;